import { r as fetchConfig } from "@theme/utils";
//#region frontend/islands/cart-featured-product-form.js
var CartFeaturedProductForm = class extends window.HTMLElement {
	connectedCallback() {
		this.form = this.querySelector("form");
		this.submitButton = this.querySelector("[type=\"submit\"]");
		this.cart = document.querySelector("cart-drawer");
		this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
		this.slide = this.closest("swiper-slide");
		if (this.slide && this.submitButton) {
			this.updateTabIndex();
			this.classObserver = new MutationObserver(() => this.updateTabIndex());
			this.classObserver.observe(this.slide, {
				attributes: true,
				attributeFilter: ["class"]
			});
		}
	}
	disconnectedCallback() {
		this.classObserver?.disconnect();
	}
	updateTabIndex() {
		this.submitButton.tabIndex = this.slide.classList.contains("swiper-slide-active") ? 0 : -1;
	}
	onSubmitHandler(evt) {
		evt.preventDefault();
		if (this.submitButton.getAttribute("aria-disabled") === "true") return;
		this.submitButton.setAttribute("aria-disabled", "true");
		this.submitButton.classList.add("loading");
		const config = fetchConfig("javascript");
		config.headers["X-Requested-With"] = "XMLHttpRequest";
		delete config.headers["Content-Type"];
		const formData = new window.FormData(this.form);
		if (this.cart) {
			formData.append("sections", this.cart.getSectionsToRender().map((s) => s.id));
			formData.append("sections_url", window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		}
		config.body = formData;
		fetch(window.routes.cart_add_url, config).then((res) => res.json()).then((response) => {
			if (response.status) {
				console.error("Cart add error:", response.description);
				return;
			}
			if (!this.cart) {
				window.location = window.routes.cart_url;
				return;
			}
			if (this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
			this.cart.renderContents(response);
		}).catch(console.error).finally(() => {
			this.submitButton.classList.remove("loading");
			this.submitButton.removeAttribute("aria-disabled");
		});
	}
};
window.customElements.define("cart-featured-product-form", CartFeaturedProductForm);
//#endregion
